import React, { useEffect, useState } from "react";

import { Container, Row } from "reactstrap";
import Filters from '../../components/Common/Filters/filters';
import { getIdFromObject } from "../../helpers/tasks_helper";
import { getDynamicAttrUpdated } from "../../helpers/tools_helper";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { ITable } from "../../components/Common/iComponents/iTable/ITable";
import { IPopUp } from "../../components/Common/iComponents/iPopUp/IpopUp";
import IForm from "./IForm";
import { getRegistrySetRequest, getRegistrySetRequestFilters } from '../../store/RegistrySetRequest/actions';


const RegistrySetRequest = () => {
    const dispatch = useDispatch();
    const groupName = 'RegistrySetRequest';

    const { listData, CountItems } = useSelector((state: any) => state.RegistrySetRequest);
    const { restartDay, restartMonth } = useSelector((state: any) => state.clients.brandCustom);
    const [isFirstRun, setIsFirstRun] = useState(true);
    const [visibleClientId, setVisibleClientId] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [popUpState, setpopUpState] = useState(false);
    const [title, setTitle] = useState('');
    const [selectedRow, setSelectedRow] = useState({});
    const [filters, setFilters] = useState({
        from: moment().set('date', restartDay).set('month',(restartMonth == 0 ? 11 :  restartMonth - 2)).format('YYYY-MM-DD'),
        to: moment().set('month', (restartMonth == 0 ? 0 : restartMonth - 1)).set('date', restartDay).format('YYYY-MM-DD'),
        order: "{'createdAt' : 'DESC'}",
        dynamicFilter: '',
    });
    const [pagination, setPagination] = useState<{
        sizePerPage: number;
        page: number;
    }>({ sizePerPage: 50, page: 1 });

    useEffect(() => {
        dispatch(getRegistrySetRequestFilters());

        let user;
        const getAuthUser = localStorage.getItem('authUser');
        if (getAuthUser) {
            user = JSON.parse(getAuthUser);
        }

        if (user?.ROL_ID == 19) {
            setVisibleClientId(true);
        }
    }, []);

    useEffect(() => {
        if (isFirstRun) {
            const filters = JSON.parse(localStorage.getItem("filterOperation") || "{}");
            if (filters[groupName]) {
                handleActionOnSearch(filters[groupName]);
            }
            setIsFirstRun(false);
        } else {
            dispatch(getRegistrySetRequest({ pagination, filters }));
        }
    }, [dispatch, filters, pagination, isFirstRun]);

    const columns = [
        {
            text: 'Date',
            visibleInTable: true,
            formatter: (cellContent: any, log: any) => <>{moment(new Date(log?.createdAt)).format()}</>
        },
        {
            text: 'Client ID',
            visibleInTable: visibleClientId,
            dataField: 'clientId',
        },
        {
            text: 'Operation Type',
            visibleInTable: true,
            dataField: 'operationType',
        },
        {
            text: 'Number',
            visibleInTable: true,
            dataField: 'Number',
        },
        {
            text: 'Description',
            visibleInTable: true,
            dataField: 'description',
        }
    ];

    const handleActionOnSearch = (data: any) => {
        if (data.taskId) {
            data.taskId.forEach((t: any) => {
                const id = getIdFromObject(t);
                t.value = id;
            });
        }
        if (data.clientId) {
            data.clientId.forEach((c: any) => {
                const id = getIdFromObject(c);
                c.value = id;
            });
        }
        const filterString = getDynamicAttrUpdated(data);
        setFilters((prevFilters) => ({
            ...prevFilters,
            order: filters.order,
            dynamicFilter: filterString
        }));
    };
    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };
    const handleActionOnRowClick = (row: any) => {
        setTitle(`${row.description} - ${row?.Number ?? row?.operationType}`);
        setSelectedRow(row);
    };
    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };
    const handleTableSort = (type: any, { sortField, sortOrder }: any) => {
        setFilters({
            ...filters,
            order: `{'${sortField ?? 'createdAt'}' : '${sortOrder.toUpperCase()}'}`
        })
    }

    return (
        <React.Fragment>
            <Container style={{ minHeight: "600px", height: "32%", overflowX: "hidden", overflowY: "auto" }}>
                <Row>
                    <Row>
                        <ITable
                            enableView={false}
                            remote={true}
                            CountItems={CountItems}
                            handlerPaginationState={handlePaginationChange}
                            data={listData}
                            fields={columns}
                            tableColumns={columns}
                            headerColorT="bg-primary text-white"
                            actionOnRowClick={handleActionOnRowClick}
                            handlePopUpState={onPopUpState}
                            groupName={groupName}
                            handleTableSort={handleTableSort}
                        />
                    </Row>
                </Row>

            </Container>

            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={title}
                modaleTitleUpdate={'Registry Set Transactions'}
                icon="shopping-bag"
                colorHeaderPop={'#101340'}
            >
                <IForm selectedRow={selectedRow} />
            </IPopUp>
        </React.Fragment>
    )
}

export default RegistrySetRequest;